@if (selectedFirmwareStatus) {
<app-firmware-update (closeSignal)="closeFirmwareUpdateDetails()"
    [firmwareStatus]="selectedFirmwareStatus"></app-firmware-update>
}

<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center pt-4">
            <div class="col-md-9 ps-5 pt-4 pb-4 d-flex align-items-center gap-3">
                <div class="button-back pb-2" [routerLink]="['/firmware-update-group']">
                    <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
                </div>
                <h2 class="col pb-2 title">{{ "FIRMWARE_UPDATE" | translate }}</h2>
            </div>
            <div class="col-md-3 pe-5 pt-4 pb-4 d-flex justify-content-end">
                <button class="button-add-device" (click)="downloadReport()">
                    {{ "DOWNLOAD_FIRMWARE_UPDATE_GROUP_REPORT" | translate }}
                </button>
            </div>
        </div>

        <div class="d-flex flex-row align-items-center g-0 m-0 p-0 mb-3">
            <div class="d-flex justify-content-start ps-5 gap-3">
                <app-firmware-update-group-details-filter [numberOfResults]="numberOfCommands"
                    [selectedAssetTypeIds]="selectedFilters.assetTypeIds || []"
                    [selectedAreas]="selectedFilters.areas || []" [selectedRegions]="selectedFilters.regions || []"
                    [selectedStatuses]="selectedFilters.statuses" (applied)="onDataReceived($event)">
                </app-firmware-update-group-details-filter>

                <app-sort (close)="onSortOption($event)"></app-sort>

                <div class="datepicker-container-wrapper position-relative">
                    <div class="button-wrapper">
                        <div class="button">
                            <img alt="Date" src="assets/core/table-button/date.svg" />
                            <div class="button-text" (click)="toggleModal()"
                                [ngClass]="{ changed: requestData.startDate && requestData.endDate }">
                                <ng-container *ngIf="requestData.startDate && requestData.endDate; else noDateSelected">
                                    {{ selectedDate }}
                                </ng-container>
                                <ng-template #noDateSelected>
                                    <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                                </ng-template>
                            </div>
                            <img *ngIf="requestData.startDate && requestData.endDate" alt="Exit"
                                src="assets/device/x.svg" (click)="clearDates()" />
                        </div>
                    </div>
                    @if (isDatepickerOpen) {
                    <div class="overlay" (click)="toggleModal()"></div>
                    <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                        [inputFromDate]="requestData.startDate" [inputToDate]="requestData.endDate">
                    </app-datepicker>
                    }
                </div>

                <app-search placeholder="{{ 'DEVICES_SEARCHBY' | translate }}"
                    (searchChange)="searchChange($event)"></app-search>
            </div>
            <div class="pe-5 d-flex selected-container justify-content-end align-items-center flex-wrap gap-2">
                <span *ngIf="selectedRows.length > 0" class="custom-color d-flex align-items-center gap-2">
                    {{ selectedRows.length }} {{ "SELECTED" | translate }}
                    <img [alt]="'CLEAR_SELECTION' | translate" src="assets/device/x.svg" (click)="clearSelection()"
                        [title]="'CLEAR_SELECTION' | translate" />
                </span>
                <button *ngIf="selectedRows.length > 0 && hasSelectedAbortableCommands()" type="button"
                    class="firmware-group-bulk-action-button" (click)="abortSelectedCommands()"
                    [title]="'ABORT' | translate" [attr.aria-label]="'ABORT' | translate">
                    <svg-icon alt="Abort" src="assets/device/delete-folder.svg"></svg-icon>
                </button>
                <button *ngIf="selectedRows.length > 0 && hasSelectedRetryableCommands()" type="button"
                    class="firmware-group-bulk-action-button" (click)="retrySelectedCommands()"
                    [title]="'RETRY' | translate" [attr.aria-label]="'RETRY' | translate">
                    <svg-icon alt="Retry" src="assets/device/refresh.svg"></svg-icon>
                </button>
                <button *ngIf="selectedRows.length > 0 && hasSelectedDeletableCommands()" type="button"
                    class="firmware-group-bulk-action-button" (click)="deleteSelectedCommands()"
                    [title]="'DELETE' | translate" [attr.aria-label]="'DELETE' | translate">
                    <svg-icon alt="Delete" src="assets/settings/trash-can-red.svg"></svg-icon>
                </button>
            </div>
        </div>

        <div class="row g-0 m-0">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th class="ps-1 fixed-col">
                            <input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelected($event)"
                                (click)="$event.stopPropagation()" class="form-check-input custom-checkbox" />
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "DEVICESETUP_METERNO" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "ASSET_TYPE" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "METER_MAKE" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "DEVICESETUP_METERMODEL" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "REGION" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "AREA" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "STARTTIME" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "ENDTIME" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "STATUS" | translate }}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{ "PROGRESS" | translate }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i = index" (click)="openFirmwareUpdateDetails(row)">
                        <td appIsNew [executedTime]="row.startTime"></td>
                        <td class="ps-1 fixed-col" (click)="checkbox.click(); $event.stopPropagation()">
                            <input type="checkbox" [checked]="isRowSelected(row.id)" [id]="'checkbox-' + row.id"
                                (change)="toggleRowSelection(row)" (click)="$event.stopPropagation()"
                                class="form-check-input custom-checkbox" #checkbox />
                        </td>
                        <td>
                            <span title="{{ row.meter.meterNumber }}">{{ row.meter.meterNumber || "/"
                                }}</span>
                        </td>
                        <td>
                            <span title="{{ row.meter.assetType }}">{{ row.meter.assetType || "/"
                                }}</span>
                        </td>
                        <td>
                            <span title="{{ row.meter.meterMake }}">{{ row.meter.meterMake || "/"
                                }}</span>
                        </td>
                        <td>
                            <span title="{{ row.meter.meterModel }}">{{ row.meter.meterModel || "/"
                                }}</span>
                        </td>
                        <td>
                            <span title="{{ row.meter.regionName }}">{{ row.meter.regionName || "/"
                                }}</span>
                        </td>
                        <td>
                            <span title="{{ row.meter.areaName }}">{{ row.meter.areaName || "/"
                                }}</span>
                        </td>
                        <td>
                            <span title="{{ row.startTime | date: 'dd MMM yyyy, h:mm a'  }}">{{ row.startTime | date:
                                "dd MMM yyyy, h:mm a" }}</span>
                        </td>
                        <td>
                            <span title="{{ row.endTime | date: 'dd MMM yyyy, h:mm a'  }}">{{ row.endTime ? (row.endTime
                                | date: "dd MMM yyyy, h:mm a")
                                : "/"
                                }}</span>
                        </td>
                        <td class="status-cell">
                            <div class="status-with-actions">
                                <span class="status-pill" [ngClass]="statusClass(row.status)">
                                    {{ statusTranslationKey(row.status) | translate }}
                                </span>
                                <button *ngIf="isAbortableCommand(row); else retryCommandButton" type="button"
                                    class="status-action-button" (click)="abortCommand(row); $event.stopPropagation()"
                                    [title]="'ABORT' | translate" [attr.aria-label]="'ABORT' | translate">
                                    <svg-icon alt="Abort" src="assets/device/delete-folder.svg"></svg-icon>
                                </button>
                                <ng-template #retryCommandButton>
                                    <button *ngIf="isRetryableCommand(row)" type="button" class="status-action-button"
                                        (click)="retryCommand(row); $event.stopPropagation()"
                                        [title]="'RETRY' | translate" [attr.aria-label]="'RETRY' | translate">
                                        <svg-icon alt="Retry" src="assets/device/refresh.svg"></svg-icon>
                                    </button>
                                </ng-template>
                                <button *ngIf="isDeletableCommand(row)" type="button" class="status-action-button"
                                    (click)="deleteCommand(row); $event.stopPropagation()"
                                    [title]="'DELETE' | translate" [attr.aria-label]="'DELETE' | translate">
                                    <svg-icon alt="Delete" src="assets/settings/trash-can-red.svg"></svg-icon>
                                </button>
                            </div>
                        </td>
                        <td>
                            <div class="progress-cell" [attr.aria-label]="statusTranslationKey(row.status) | translate">
                                <div class="progress-track" role="progressbar"
                                    [attr.aria-valuenow]="progressPercent(row)" aria-valuemin="0" aria-valuemax="100">
                                    <div class="progress-fill" [style.width.%]="progressPercent(row)"></div>
                                </div>
                                <span class="progress-label">{{ progressPercent(row) }}%</span>
                            </div>
                        </td>
                    </tr>

                    <tr *ngIf="data.length === 0">
                        <td colspan="12" class="empty-state">{{ "NO_DATA" | translate }}</td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="container-down">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
        [currentPage]="currentPage" (pageChange)="pageChange($event)">
    </app-pagination>
</div>

<app-confirm-dialog *ngIf="isAbortModalOpen" titleKey="ABORT" question="FIRMWARE_UPDATE_ABORT_CONFIRM"
    (confirm)="confirmAbortCommands()" (cancel)="closeAbortModal()"></app-confirm-dialog>
